import { DEFAULT_HOURS_PER_DAY, getHoursPerDayOrDefault } from "routes/rate-cards/capacity-constants.mjs"

const CURRENCY_SYMBOLS = { GBP: "\u00a3", USD: "$", EUR: "\u20ac" }

export function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || currency || "\u00a3"
}

export function formatMoney(value) {
    return (value || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatFullMoney(value, currencySymbol, options = {}) {
    const num = Number(value) || 0
    const sign = getSign(num, options.showPlus)
    return `${sign}${currencySymbol || ""}${formatMoney(Math.abs(num))}`
}

export function formatNumber(value) {
    return (value || 0).toLocaleString("en-GB")
}

export function round2(n) {
    return Math.round((n || 0) * 100) / 100
}

export function formatHoursMinutes(decimalHours) {
    let hours = Math.floor(decimalHours || 0)
    let minutes = Math.round(((decimalHours || 0) - hours) * 60)
    if (minutes === 60) {
        hours++
        minutes = 0
    }
    return `${hours}h ${minutes.toString().padStart(2, "0")}m`
}

export { DEFAULT_HOURS_PER_DAY }

export function formatWorkingDays(decimalHours, hoursPerDay) {
    const totalHours = decimalHours || 0
    const perDay = getHoursPerDayOrDefault(hoursPerDay)
    if (totalHours < perDay) return formatHoursMinutes(totalHours)
    const days = Math.round(totalHours / perDay)
    return `${days.toLocaleString("en-GB")} w/days`
}

export function formatLargeNumber(value, currencySymbol) {
    const num = Number(value) || 0
    const abs = Math.abs(num)
    const sign = getSign(num)
    if (shouldFormatAsMillions(abs)) return `${sign}${currencySymbol || ""}${(abs / 1000000).toFixed(1)}M`
    if (abs >= 1000) return `${sign}${currencySymbol || ""}${(abs / 1000).toFixed(1)}K`
    return formatFullMoney(num, currencySymbol)
}

export function isLargeNumber(value) {
    return Math.abs(Number(value) || 0) >= 1000
}

export function formatDuration(hours) {
    const h = hours || 0
    if (h < 8) return `${round2(h)} hours`
    const days = h / 8
    if (days < 260) return `${round2(days)} days`
    const years = days / 260
    return `${round2(years)} years`
}

export function formatDate(date) {
    if (!date) return "\u2014"
    const d = new Date(date)
    if (isNaN(d.getTime())) return "\u2014"
    const day = d.getDate()
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    const month = months[d.getMonth()]
    const year = d.getFullYear()
    return `${day} ${month}, ${year}`
}

function getSign(value, showPlus) {
    if (value < 0) return "-"
    if (showPlus && value > 0) return "+"
    return ""
}

function shouldFormatAsMillions(value) {
    if (value >= 1000000) return true
    if (value < 1000) return false
    return Number((value / 1000).toFixed(1)) >= 1000
}
